export const SUBSCRIPTION_PRICE_MAP = {
    // DIAMOND
    DIAMOND_1: {
        priceId: 'price_1RmfFa03HSHmHwgRfBE980pq', // Live
        // priceId: 'price_1RllrdP2sW8AejKtDg1uLJ4O', // Test
        type: 'diamond',
        price: 10,
        name: '100 Diamonds'
    },
    DIAMOND_2: {
        priceId: 'price_1RmfGT03HSHmHwgRNbpQhk8Y',
        type: 'diamond',
        price: 50,
        name: '600 Diamonds'
    },
    DIAMOND_3: {
        priceId: 'price_1RmfGn03HSHmHwgRchjA0YoB',
        type: 'diamond',
        price: 100,
        name: '1300 Diamonds'
    },

    // SUPER SELLER
    SUPER_SELLER_1: {
        priceId: 'price_1RmfKs03HSHmHwgRY5So28HQ', // Live
        // priceId: 'price_1RlLJSP2sW8AejKtt6Z2SQ7Y', // Test
        type: 'subscription',
        name: 'Super Seller Plan ( PROMO )'
    },
    SUPER_SELLER_2: {
        priceId: 'price_1RofUQ03HSHmHwgRB6z2i8dY', // Live
        type: 'subscription',
        name: 'Advanced Seller Plan'
    },
    SUPER_SELLER_3: {
        priceId: 'price_1RmfM403HSHmHwgRWvO7lFhq', // Live
        type: 'subscription',
        name: 'Super Seller Plan'
    }
};
